/**
 * RTWO Blockchain Core Foundation — Configuration
 * RTWO v2.2 | Module ID: RTWO-BLCK-001
 */

export function isBlockchainCoreEnabled(): boolean {
  const flag = process.env.RTWO_BLOCKCHAIN_CORE_ENABLED?.trim().toLowerCase();
  if (flag === 'false') {
    return false;
  }
  return true;
}

export function isBlockchainCoreBackendEnabled(): boolean {
  const flag = process.env.RTWO_BLOCKCHAIN_CORE_BACKEND_ENABLED?.trim().toLowerCase();
  return flag === 'true';
}

export const BLOCKCHAIN_CORE_API_ROUTES = {
  latestBlock: '/api/runtime/blockchain-core/latest-block',
  blockLookup: '/api/runtime/blockchain-core/block-lookup',
} as const;
